






















import BaseComponent from '@/components/base-component.vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';

@Component
export default class ClientUnitDeliveryRoutes extends BaseComponent {
  @Prop()
  public data: any[];

  public headersDeliveryRoutes: any = [
    { text: 'Cód. Rota', value: 'codigoRota', sortable: true, align: 'left' },
    { text: 'Cód. Endereço', value: 'codigo', sortable: true, align: 'center' },
    { text: 'Tipo Bolsa', value: 'tipoBolsa', sortable: true, align: 'center' },
    { text: 'Descrição', value: 'descricao', sortable: true, align: 'left' },
    { text: 'Horário Máximo Prescrição', value: 'horarioMaximoPrescricao', sortable: true, align: 'center' },
    { text: 'Horário Saída', value: 'horarioSaida', sortable: true, align: 'center' },
    { text: 'Horário Entrega', value: 'horarioEntrega', sortable: true, align: 'center' },
    { text: 'Frete', value: 'frete', sortable: true, align: 'right' },
    { text: 'Frete Pós Horário', value: 'fretePos', sortable: true, align: 'right' }
  ];
}
